var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M708.42,775.55c75.63,0,137.14-61.51,137.14-137.14V221.48c0-75.59-61.51-137.1-137.14-137.1H139.09C63.5,84.38,1.99,145.88,1.99,221.48v416.93c0,75.63,61.5,137.13,137.1,137.14h569.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M884.67,939.62c75.71,0,137.34-61.49,137.34-137.05h0v-418.37c0-56.9-35.71-106.15-85.7-126.68v380.89c0,125.67-102.22,227.88-227.88,227.88H209.3c22.89,43.94,68.77,73.33,121.49,73.33h553.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTemplate);
export default __webpack_public_path__ + "static/media/menu-template.1c8e36d961ccfb89813b9e3bd8a5a17e.svg";
export { ForwardRef as ReactComponent };